module.exports = __webpack_public_path__ + "static/media/Brett Johnson.63d3bbc3.png";